/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountByMediaType
 */
export interface CountByMediaType {
    /**
     * メディア種類ID
     * @type {number}
     * @memberof CountByMediaType
     */
    mediaTypeId: number;
    /**
     * メディア種類名
     * @type {string}
     * @memberof CountByMediaType
     */
    mediaTypeName: string;
    /**
     * メディア種類IDに一致するメディアの数
     * @type {number}
     * @memberof CountByMediaType
     */
    totalCount: number;
}

export function CountByMediaTypeFromJSON(json: any): CountByMediaType {
    return CountByMediaTypeFromJSONTyped(json, false);
}

export function CountByMediaTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountByMediaType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaTypeId': json['media_type_id'],
        'mediaTypeName': json['media_type_name'],
        'totalCount': json['total_count'],
    };
}

export function CountByMediaTypeToJSON(value?: CountByMediaType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_type_id': value.mediaTypeId,
        'media_type_name': value.mediaTypeName,
        'total_count': value.totalCount,
    };
}

